<template>
    <div class="page">
        <div class="pageindex pageindex-left" @click="left"></div>
        <div 
            class="pageindex"
            :class="{'pageindex-active': item == page_index_inside}"
            v-for="(item, index) in page_num_list"
            :key="index"
            @click="changeIndex(item)"
        >
            {{item}}
        </div>
        <div class="pageindex pageindex-right" @click="right"></div>
        <div v-if="0">共{{page_total}}页</div>
    </div>
</template>

<script>
export default {
    name: "page",
    props: {
        // zongyeshu
        page_total: {
            type: Number,
            default: 0
        },
        // yema
        page_index: {
            type: Number,
            default: 1
        },
        // yiyeduoshaotiao
        page_size: {
            type: Number,
            default: 10
        }
    },
    components: {

    },
    data: () => ({
        // ye ma
        page_index_inside: 0,
        // 一共多少页
        page_num: 0,

        max_show_page_num: 9
    }),
    created() {
        this.page_index_inside = this.page_index
    },
    mounted() {

    },
    watch: {
        page_total(to) {
            this.page_num = Math.ceil(to /this.page_size)
        }
    },
    computed: {
        page_num_list() {
            let list = []

            let offset = Math.floor(this.max_show_page_num / 2)
            
            let index = this.page_index_inside < this.max_show_page_num ? 1 : this.page_index_inside - offset
            let limit = Math.min(index + this.max_show_page_num - 1, this.page_num)
            for (let i = index; i <= limit; i++) {
                list.push(i)
            }
            return list
        }
    },
    methods: {
        changeIndex(index) {
            this.page_index_inside = index
            this.$emit('change', index)
        },
        left() {
            if (this.page_index_inside != 1) {
                this.page_index_inside -= 1
                this.$emit('change', this.page_index_inside)
            }
        },
        right() {
            if (this.page_index_inside != this.page_num) {
                this.page_index_inside += 1
                this.$emit('change', this.page_index_inside)
            }
        }
    },
};
</script>

<style lang="scss" scoped>
$color: aliceblue;
.page {
    display: flex;
    justify-content: center;
    align-items: center;
    .pageindex{
        font-family: "Noto Sans JP", sans-serif;
        color: white;
        font-weight: 900;
        display: inline-block;
        // border: 1px solid $color;
        color: $color;
        font-size:  pxTorem(16px);
        text-align: center;
        padding: pxTorem(2px) pxTorem(10px);
        cursor: pointer;
        &-active {
            color: #56dbfb;
        }
    }
    .pageindex-left{
        margin-right: pxTorem(5px);
        background: url(../assets/images/news/left.png);
        background-size:100% 100%;
        width: pxTorem(12px);
        height: pxTorem(11px);
    }
    .pageindex-right{
        margin-left: pxTorem(5px);
        background: url(../assets/images/news/right.png);
        background-size:100% 100%;
        width: pxTorem(12px);
        height: pxTorem(11px);
    }
}
@media screen and (max-width: 600px) {
    .page {
        .pageindex {
            font-size:  MpxTorem(50px);
            margin: 0 MpxTorem(5px);
        }
        .pageindex-left{
            margin-right: MpxTorem(15px);
            width: MpxTorem(22px);
            height: MpxTorem(21px);
        }
        .pageindex-right{
            margin-left: MpxTorem(15px);
            width: MpxTorem(22px);
            height: MpxTorem(21px);
        }
    }
}
</style>
